import { getDeviceType } from '@/shared/lib/browser';

const FT = {
  A: '41', // disable Contact Sales button
  B: '40', // enable Contact Sales button
};

export const getABTestGroup = (mobilePercentage: number, webPercentage: number) => {
  const rand = Math.random();
  const deviceType = getDeviceType();
  const testType =
    (deviceType === 'desktop' && rand <= webPercentage / 100) ||
    (deviceType !== 'desktop' && rand <= mobilePercentage / 100)
      ? 'B'
      : 'A';

  return FT[testType];
};
